// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__0-Z7H","link":"Logo_link__g61Xi"};